<template>
    <!-- 总部按职能部门 -->
    <div v-loading="loading" class="business-expense-name">
        <container-title title="总部按职能部门" />
        <div class="main-container-content">
            <el-form label-width="110px" class="search-form">
                <el-row :gutter="24">
                    <el-col :span="8">
                        <el-form-item label="报表截止月份">
                            <el-date-picker v-model="yearMonth" type="month" format="yyyy年MM月" value-format="yyyyMM"
                                :disabled="loading" :clearable="false" placeholder="请选择报表截止月份" class="mid-el-width" @change="refresh">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="16">
                        <div class="budget-info-text">
                            执行数据：{{ resData.budgetYear }}年{{ resData.executeMonth }}月 | 预算口径：{{ resData.budgetYear }}年{{ yearTimes }}
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="24">
                    <el-col :span="24">
                        <div class="status-actions-wrapper">
                            <div class="left-status">
                                <span class="status-label">状态:</span>
                                <span class="status-value">{{ archiveStatus | reportStatusFilters }}</span>
                            </div>
                            <div class="right-btns left-status">
                                <span class="status-label">单位：万元</span>
                                <el-button class="ml-10" v-throttle="[archiveReport,`click`,1000]" :disabled="loading" type="primary"
                                    >{{ archiveStatus == 1 ? '取消归档' : '归档' }}</el-button>
                                <el-button class="ml-10" :disabled="loading" v-throttle="[exportAll,`click`,1000]">导出数据</el-button>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
            <div class="mb-12">
            </div>
            <el-table
                ref="tableRef"
                :data="processedTableData"
                border
                :max-height="tableHeight"
                :cell-style="getCellStyleByColumn(resData.executeRate, ['budgetExecuteRate', 'budgetExecuteRateExcludeWaitShare'])"
                :row-class-name="tableRowClassName"
                class="budget-report-table"
            >
                <!-- 一级预算单位列 -->
                <el-table-column prop="firstDeptName" label="一级预算单位" width="150" fixed="left" align="left">
                    <template slot-scope="scope">
                        <el-tooltip 
                            v-if="shouldShowTooltip(scope.$index)" 
                            :content="scope.row.firstDeptName" 
                            placement="top"
                            effect="dark"
                        >
                            <span :class="getfirstDeptNameClass(scope.$index, scope.row)">{{ scope.row.firstDeptName }}</span>
                        </el-tooltip>
                        <span v-else :class="getfirstDeptNameClass(scope.$index, scope.row)">{{ scope.row.firstDeptName }}</span>
                    </template>
                </el-table-column>

                <!-- 业务预算 -->
                <el-table-column prop="businessAmount" :label="`${resData.budgetYear || ''}年${resData.halfMonth || ''}月业务预算`" width="200" align="right">
                    <template slot-scope="scope">
                        {{ formatNumber(scope.row.businessAmount) }}
                    </template>
                </el-table-column>
                <!-- 实际 -->
                <el-table-column prop="executeAmount" :label="`${resData.budgetYear || ''}年${resData.executeMonth || ''}月实际`" width="200" align="right">
                    <template slot-scope="scope">
                        {{ formatNumber(scope.row.executeAmount) }}
                    </template>
                </el-table-column>
                <el-table-column prop="executeAmountLoan" label="未核销借款" width="150" align="right">
                    <template slot-scope="scope">
                        {{ formatNumber(scope.row.executeAmountLoan) }}
                    </template>
                </el-table-column>
                <!-- 执行实际 -->
                <el-table-column prop="executeTotal" :label="`${resData.budgetYear || ''}年${resData.halfMonth || ''}月执行合计`" width="200" align="right">
                    <template slot-scope="scope">
                        {{ formatNumber(scope.row.executeTotal) }}
                    </template>
                </el-table-column>
                <el-table-column prop="executeAmountWaitShare" label="其中待分摊" width="150" align="right">
                    <template slot-scope="scope">
                        {{ formatNumber(scope.row.executeAmountWaitShare) }}
                    </template>
                </el-table-column>
                <!-- 实际执行(删除待分摊) -->
                <el-table-column prop="executeTotalExcludeWaitShare" :label="`${resData.budgetYear || ''}年${resData.halfMonth || ''}月实际执行(删除待分摊)`" width="250" align="right">
                    <template slot-scope="scope">
                        {{ formatNumber(scope.row.executeTotalExcludeWaitShare) }}
                    </template>
                </el-table-column>
                <el-table-column :label="`预算执行率(${resData.executeRate}%)`" width="200" align="right">
                    <template slot-scope="scope">
                        {{ formatPercent(scope.row.budgetExecuteRate) }}
                    </template>
                </el-table-column>
                <!-- 预算执行率(删除待分摊) -->
                <el-table-column :label="`预算执行率(删除待分摊) (${resData.executeRate}%)`" width="230" align="right">
                    <template slot-scope="scope">
                        {{ formatPercent(scope.row.budgetExecuteRateExcludeWaitShare) }}
                    </template>
                </el-table-column>
                <!-- 去年同期实际执行 -->
                <el-table-column prop="executeAmountPre" :label="`${resData.lastYear || ''}年${resData.executeMonth || ''}月实际执行`" width="200" align="right">
                    <template slot-scope="scope">
                        {{ formatNumber(scope.row.executeAmountPre) }}
                    </template>
                </el-table-column>
                <el-table-column prop="yearOnYearChange" label="同比变化(¥)" width="150" align="right">
                    <template slot-scope="scope">
                        {{ formatNumber(scope.row.yearOnYearChange) }}
                    </template>
                </el-table-column>
                <el-table-column prop="yearOnYearChangePercent" label="同比变化(%)" width="150" align="right">
                    <template slot-scope="scope">
                        {{ formatPercent(scope.row.yearOnYearChangePercent) }}
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>

import { defineComponent, ref, reactive, onMounted, onBeforeUnmount, getCurrentInstance, computed, nextTick } from 'vue'
import { awaitWrapper, downloadFileFromUrl } from "@/common/utils/assist.js";
import { usePageDto } from '@/common/mixins/usePageDto'
import { useSetTableHeight } from '@/common/mixins/useSetTableHeight'

import { preMonth } from '@/common/functions/formatters'
import { currencyNoSymbol } from "@/common/utils/assist.js";

import {
    queryReportBranchType,
    archiveReportBranchType, // 归档 1归档 2取消归档 3导出 4查询
    exportReportBranchType, // 导出数据
    modReportTotalSpecialDept, // 修改部门金额
} from './request.js'

// import EditableCell from './EditableCell.vue'
import {
    getCellStyleByColumn,
    reportStatusFilters,
    processHeadquarterByDeptData
} from '../util.js'
export default defineComponent({
    components: {
        // EditableCell
    },
    filters: {
        reportStatusFilters: reportStatusFilters
    },
    setup(props, context) {
        const { proxy } = getCurrentInstance()
        const loading = ref(false)
        const yearMonth = ref(preMonth())
        const resData = ref({})
        const initTableData = ref([]) // 表格数据
        const archiveStatus = ref(0) // 归档 0未归档 1已归档

        const fetchList = async (type) => {
            const params = {
                yearMonth: yearMonth.value,
                type: ![1,2,3,4].includes(type) ? 4 : type, // 操作 1归档 2取消归档 3导出 4查询
            }
            loading.value = true
            const [, res] = await awaitWrapper(queryReportBranchType(params))
            loading.value = false
            
            if (res && res.code == 0 && res.data) {
                resData.value = res.data
                archiveStatus.value = res.data.archiveStatus || 0
                
                const rawList = res.data.reportDetailList || []
                
                // 找到合计行（最后一行）
                if (rawList.length > 0) {
                    const summaryRow = rawList[rawList.length - 1]
                    const otherRows = rawList.slice(0, -1)
                    
                    // 计算合计行：将其他所有行的数值字段求和
                    const summaryFields = ['businessAmount', 'executeAmount', 'executeAmountLoan', 'executeAmountWaitShare', 'executeAmountPre']
                    summaryFields.forEach(field => {
                        summaryRow[field] = otherRows.reduce((sum, row) => {
                            return sum + (row[field] || 0)
                        }, 0)
                    })
                }
                
                initTableData.value = [...rawList]
            }
        }
        const archiveReport = async () => { // 归档 0未归档 1已归档
            // 二次确认
            const confirmMessage = archiveStatus.value == 1 ? '是否确认取消归档？' : '是否确认归档？'
            try {
                await proxy.$confirm(confirmMessage, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                
                // 用户确认后执行归档操作
                const params = {
                    yearMonth: yearMonth.value,
                    type: archiveStatus.value == 1 ? 2 : 1, // 1归档 2取消归档 3导出 4查询 
                }
                loading.value = true
                const [, res] = await awaitWrapper(archiveReportBranchType(params))
                loading.value = false
                if (res && res.code == 0) {
                    proxy.$message.success(archiveStatus.value === 1 ? '取消归档成功' : '归档成功')
                    fetchList(4)
                }
            } catch (error) {
                // 用户取消操作，不做任何处理
            }
        }

        // 计算处理后的表格数据
        const processedTableData = computed(() => {
            // 使用 processHeadquarterByDeptData 函数处理数据
            return processHeadquarterByDeptData(initTableData.value, resData.value.executeRate)
        })

        // 格式化数字（四舍五入两位小数）
        const formatNumber = (value) => {
            if (value === null || value === undefined) {
                return '--'
            }
            return currencyNoSymbol(value)
        }

        // 格式化百分比
        const formatPercent = (value) => {
            if (value === null || value === undefined) {
                return '/'
            }
            if (value > -0.4 && value < 0.4) {
                return '0%'
            }
            return parseFloat(value).toFixed(0) + '%'
        }

        // 表格行样式（根据行数判断）
        const tableRowClassName = ({ row, rowIndex }) => {
            // group-summary-row：表格第三行（body 第1行，rowIndex 0）
            // if (rowIndex === 0) {
            //     return 'summary-row'
            // }
            return ''
        }

        // 部门名称样式（根据行数判断）
        const getfirstDeptNameClass = (rowIndex, row) => {
            if (rowIndex === 0) {
                return 'dept-name-group-summary'
            }
            return 'dept-name-normal'
        }

        const tableRef = ref(null)
        const { pageDto, refresh, changePage, changeSize } = usePageDto(fetchList, tableRef)
        const height = ref(180)
        const { tableHeight, calcHeight } = useSetTableHeight({
            height: height.value,
            pageDto: pageDto,
            tableRef: tableRef
        })


        onMounted(async () => {
            fetchList(4)
        })

        const exportAll = async () => {
            const params = {
                yearMonth: yearMonth.value,
                type: 3,
            }
            loading.value = true
            const [, res] = await awaitWrapper(exportReportBranchType(params))
            loading.value = false
            if (res && res.code == 0) {
                try {
                    loading.value = true
                    await downloadFileFromUrl(res.data, '预算分析报表-总部按职能部门-' + yearMonth.value.slice(0, 4) + '年' + yearMonth.value.slice(4, 6) + '月.xlsx')
                    loading.value = false
                    proxy.$message.success('导出成功')
                } catch (error) {
                    // proxy.$message.error('下载失败')
                }
            }
        }
        // 判断是否需要显示悬浮提示
        const shouldShowTooltip = (rowIndex) => {
            return true
        }

        // 计算上半年/下半年显示
        const yearTimes = computed(() => {
            if (!resData.value.halfMonth) {
                return ''
            }
            const halfMonthStr = String(resData.value.halfMonth)
            return halfMonthStr.startsWith('1') ? 'H1' : 'H2'
        })

        return {
            tableRef,
            tableHeight,
            calcHeight,
            loading,
            yearMonth,
            pageDto,
            refresh,
            changePage,
            changeSize,
            archiveStatus,
            archiveReport,
            exportAll,
            resData,
            processedTableData,
            formatNumber,
            formatPercent,
            tableRowClassName,
            getfirstDeptNameClass,
            getCellStyleByColumn,
            shouldShowTooltip,
            yearTimes
        }
    },
})
</script>
<style lang="scss" scoped>
.main-container-content {
    padding: 20px;
    background-color: #fff;
}

.business-expense-name {
    background: #fff;
    -webkit-box-shadow: 0 2px 4px 0 #dbdee7;
    box-shadow: 0 2px 4px 0 #dbdee7;
    border-radius: 4px;
    margin: 16px;
}

.ml-10 {
    margin-left: 10px;
}

.mb-12 {
    margin-bottom: 12px;
}

.search-form {
    width: 100%;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
}

.status-actions-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    flex: 1;
}

.left-status {
    display: flex;
    align-items: center;
    padding-left: 15px;
    font-size: 14px;

    .status-label {
        color: #909399;
        margin-right: 8px;
    }

    .status-value {
        color: #409EFF;
        font-weight: 500;
        padding: 2px 8px;
        background-color: #ecf5ff;
        border-radius: 3px;
    }
}

.right-btns {
    display: flex;
    gap: 10px;
}

.budget-info-text {
    padding-left: 15px;
    font-size: 14px;
    color: #606266;
    line-height: 32px;
}

// 表格样式
.budget-report-table {
    ::v-deep .el-table__header {
        th {
            background-color: #c70000 !important; // 深红色背景
            color: #fff !important; // 白色文字
            font-weight: bold;
            text-align: center;
            .cell {
                color: #fff !important; // 白色文字
                font-weight: bold;
            }
        }
    }

    // 集团汇总行（浅黄色背景）
    ::v-deep .group-summary-row {
        background-color: #fff5d0 !important; // 浅黄色
        font-weight: bold;
    }

    // 其他汇总行（浅灰色背景）
    ::v-deep .summary-row {
        background-color: #dedede !important; // 浅灰色
        font-weight: bold;
    }

    // 子项行（白色背景，缩进）
    ::v-deep .sub-item-row {
        background-color: #fff;
    }

    // 部门名称样式
    .dept-name-group-summary {
        font-weight: bold;
        color: #000;
    }

    .dept-name-summary {
        font-weight: bold;
        color: #000;
    }

    .dept-name-sub-item {
        padding-left: 20px;
        color: #000;
    }

    .dept-name-normal {
        color: #000;
    }
}
.budget-report-table {
    ::v-deep .el-table__header {
        th {
            background-color: #c70000 !important;
            color: #fff !important;
            font-weight: bold;
            text-align: center;
            border-color: #333 !important;
            .cell {
                color: #fff !important;
                font-weight: bold;
            }
        }
    }

    // 集团汇总行（浅黄色背景）
    ::v-deep .group-summary-row {
        background-color: #fff5d0 !important;
        font-weight: bold;
        
        td {
            border-color: #333 !important;
        }
    }

    // 其他汇总行（浅灰色背景）
    ::v-deep .summary-row {
        background-color: #dedede !important;
        font-weight: bold;
        
        td {
            border-color: #333 !important;
        }
    }

    // 子项行（白色背景，缩进）
    ::v-deep .sub-item-row {
        background-color: #fff;
        
        td {
            border-color: #333 !important;
        }
    }

    // ... 其他样式保持不变
}
::v-deep .el-table--group, ::v-deep .el-table--border th, ::v-deep .el-table--border td {
    border-color: #999 !important;
}
/* 消除固定列残影 - 综合方案 */
::v-deep .el-table__fixed,
::v-deep .el-table__fixed-right {
    /* 强制硬件加速 */
    transform: translate3d(0, 0, 0);
    -webkit-transform: translate3d(0, 0, 0);
    will-change: transform;
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
    perspective: 1000px;
    -webkit-perspective: 1000px;
    
    /* 层级和定位 */
    z-index: 11 !important;
    position: absolute !important;
    
    /* 隐藏溢出，防止残影 */
    overflow: hidden !important;
    
    /* 优化渲染 */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

/* 优化固定列阴影 */
::v-deep .el-table__fixed {
    box-shadow: 2px 0 6px rgba(0, 0, 0, 0.12) !important;
    right: auto !important;
}

/* 固定列内部容器也需要优化 */
::v-deep .el-table__fixed-header-wrapper,
::v-deep .el-table__fixed-body-wrapper,
::v-deep .el-table__fixed-right .el-table__fixed-header-wrapper,
::v-deep .el-table__fixed-right .el-table__fixed-body-wrapper {
    transform: translate3d(0, 0, 0);
    -webkit-transform: translate3d(0, 0, 0);
    overflow: hidden !important;
}

/* 表格主容器优化 */
::v-deep .el-table {
    transform: translate3d(0, 0, 0);
    -webkit-transform: translate3d(0, 0, 0);
}

/* 表格body优化，防止滚动时产生残影 */
::v-deep .el-table__body-wrapper {
    transform: translate3d(0, 0, 0);
    -webkit-transform: translate3d(0, 0, 0);
    overflow: auto !important;
}
</style>
